import React, {useCallback, useMemo} from 'react';
import TooltipInput from '@/components/TooltipInput/TooltipInput';
import fieldInfoContent from '@/Pages/ProductionCost/constants/fieldInfoContent';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {updateVehicleEntryByIds} from '@/Pages/ProductionCost/store/slice';
import {validateInputNumber} from '@/Pages/Common/Utils';
import {FlixStandardCostOverwriteProps} from './FlixStandardCostOverwrite.types';
import styles from './FlixStandardCostOverwrite.module.scss';

const FlixStandardCostOverwrite: React.FC<FlixStandardCostOverwriteProps> = ({
  value,
  entryId,
  currency,
  disabled,
  errors
}) => {
  const dispatch = useAppDispatch();

  const id = `entry-${entryId}-flix-standard-cost-overwrite`;

  const handleInputChange = useCallback(
    (editedValue: string) => {
      const flixStandardCostOverwrite =
        validateInputNumber(editedValue, value ? value.toString() : '', 6, 0) ??
        undefined;

      dispatch(
        updateVehicleEntryByIds({
          entryIds: [entryId],
          updates: {flixStandardCostOverwrite}
        })
      );
    },
    [entryId, value, dispatch]
  );

  const formattedValue = useMemo(
    () => (typeof value === 'number' ? value.toString() : ''),
    [value]
  );

  return (
    <span className={styles.container}>
      <TooltipInput
        id={id}
        name="flix-standard-cost-overwrite"
        label={`Flix standard cost overwrite per month`}
        value={formattedValue}
        tooltipContent={fieldInfoContent.flixStandardCostOverwrite}
        handleInputChange={handleInputChange}
        inlineLabelLeft={currency}
        disabled={disabled}
        valid={!errors?.notAllowed}
        infoError={errors?.notAllowed}
      />
    </span>
  );
};

export default React.memo(FlixStandardCostOverwrite);
